// src/features/spotting/pages/Home.jsx
// SEO OPTIMIZED - MAY 2026
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Search, Pin } from 'lucide-react';
import { PinterestGrid } from '../../../components/shared/PinterestGrid';

export const Home = ({ sightings, loading, showToast, setReportId, setZoomImg }) => {
  const [searchQuery, setSearchQuery] = useState('');
  
  const filtered = sightings
    .filter(s => {
      if (s.hidden) return false;
      const plate = s.plate?.toLowerCase() || '';
      const brand = s.brand?.toLowerCase() || '';
      const search = searchQuery.toLowerCase();
      
      return plate.includes(search) || brand.includes(search);
    })
    .sort((a, b) => {
      // PINNED FIRST - przypięte na górze
      if (a.isPinned && !b.isPinned) return -1;
      if (!a.isPinned && b.isPinned) return 1;
      
      // Potem sortuj po upvotes
      return (b.upvotes || 0) - (a.upvotes || 0);
    });

  if (loading) return <div className="p-12 text-center text-gray-500">Ładowanie...</div>;

  // Count pinned posts
  const pinnedCount = filtered.filter(s => s.isPinned).length;
  const totalSpots = filtered.length;

  return (
    <>
      <Helmet>
        {/* SEO OPTIMIZED - DUAL PURPOSE: Car Spotting + Chamstwo Drogowe */}
        <title>Car Spotting Polska + Chamstwo Drogowe | Zgłoś Dzban Roku 2026 | Motoradar24</title>
        <meta name="description" content={`${totalSpots}+ zdjęć aut w Polsce. Car spotting: Lamborghini, Ferrari, Porsche spotted. Chamstwo drogowe: zgłoś mistrza parkowania i złe parkowanie. Dzban Roku 2026 - TY decydujesz! Społeczność walcząca z chamstwem i kochająca supersamochody.`} />
        <meta name="keywords" content="car spotting polska, chamstwo drogowe, mistrz parkowania, dzban roku 2026, złe parkowanie, spotted cars, egzotyczne auta polska, zgłoś chamstwo drogowe, supersamochody warszawa, car spotting kraków, ferrari spotted, lamborghini polska, ranking parkowanie" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Car Spotting Polska + Chamstwo Drogowe - Dzban Roku 2026 | Motoradar24" />
        <meta property="og:description" content={`${totalSpots}+ spotów aut. Zgłoś chamstwo drogowe i mistrza parkowania. Dzban Roku 2026 - zagłosuj teraz!`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://motoradar24.pl/" />
        <meta property="og:image" content="https://motoradar24.pl/og-image.jpg" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Car Spotting + Chamstwo Drogowe | Motoradar24" />
        
        {/* Canonical + Robots */}
        <link rel="canonical" href="https://motoradar24.pl/" />
        <meta name="robots" content="index, follow, max-image-preview:large" />
      </Helmet>

      <div className="max-w-7xl mx-auto p-4 pb-32 lg:pb-4">
        {/* H1 with KEYWORDS - visible for SEO, screen readers */}
        <h1 className="sr-only">
          Motoradar24 - Car Spotting Polska i Chamstwo Drogowe | Zgłoś Dzban Roku 2026 | Mistrz Parkowania
        </h1>

        <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl py-4 mb-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} aria-hidden="true" />
            <input 
              type="text" 
              placeholder="Szukaj tablicy, marki lub chamstwa drogowego..." 
              className="w-full pl-10 pr-4 py-3 bg-gray-100 text-sm font-medium text-slate-900 rounded-xl border-none outline-none focus:ring-2 focus:ring-blue-500 transition-all placeholder:text-gray-400" 
              value={searchQuery} 
              onChange={(e) => setSearchQuery(e.target.value)}
              aria-label="Wyszukaj car spotting po tablicy rejestracyjnej lub marce auta, albo chamstwo drogowe"
            />
          </div>
          
          {pinnedCount > 0 && (
            <div className="mt-3 flex items-center gap-2 text-xs text-amber-600 font-semibold">
              <Pin size={14} aria-hidden="true" />
              <span>{pinnedCount} {pinnedCount === 1 ? 'przypięty post' : 'przypięte posty'}</span>
            </div>
          )}
        </div>

        <PinterestGrid 
          sightings={filtered} 
          showToast={showToast} 
          setReportId={setReportId}
          setZoomImg={setZoomImg}
        />
      </div>
    </>
  );
};